import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import { useAuth } from './useAuth';
import { TenantContext } from './tenantCtx';

const STORAGE_KEY = 'shell_tenant_code';

export function TenantProvider({ children }) {
  const { user, token } = useAuth();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!token || !user) {
      setTenant(null);
      setLoading(false);
      return null;
    }
    try {
      const headerCode = (() => {
        try { return localStorage.getItem(STORAGE_KEY) || null; } catch { return null; }
      })();
      const r = await api.get('/platform/tenant-context', {
        headers: headerCode ? { 'X-Tenant-Code': headerCode } : undefined,
      });
      const ctx = r.data?.data || user?.tenant_context || null;
      setTenant(ctx);
      if (ctx?.tenant_code) {
        try { localStorage.setItem(STORAGE_KEY, ctx.tenant_code); } catch { /* noop */ }
      }
      return ctx;
    } catch {
      setTenant(user?.tenant_context || null);
      return user?.tenant_context || null;
    } finally {
      setLoading(false);
    }
  }, [token, user]);

  useEffect(() => {
    setLoading(true);
    load();
  }, [load]);

  const value = useMemo(
    () => ({ tenant, loading, reload: load }),
    [tenant, loading, load],
  );

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  return useContext(TenantContext);
}
